import React, {Component} from 'react';
import styles from './App.module.css';
import {Route, Switch} from 'react-router-dom'
import asyncComponent from "../components/AsyncComponent";


class App extends Component {
    render() {
        return (
            <div className={styles.App}>
                <Switch>
                    <Route path={'/test'} component={asyncComponent(() => import("./test"))}/>
                    <Route path={'/location/:no'} component={asyncComponent(() => import("./location-map"))}/>
                    <Route path={'/login'} component={asyncComponent(() => import("./login"))}/>
                    <Route path={'/'} component={asyncComponent(() => import("./index"))}/>
                </Switch>
            </div>
        );
    }
}

export default App;
